/**
 * ADMIN MODULE — page layout.
 * Wraps every admin route with the sidebar nav + a content column. Imports the
 * scoped admin stylesheet once here so every admin page is styled.
 */

import AdminNav from "./AdminNav.jsx";
import "../admin.css";

export default function AdminLayout({ title, subtitle, children }) {
  return (
    <div className="admin-shell">
      <AdminNav />
      <div>
        {(title || subtitle) && (
          <header className="admin-page-head">
            {title && <h1>{title}</h1>}
            {subtitle && <p className="sub">{subtitle}</p>}
          </header>
        )}
        {children}
      </div>
    </div>
  );
}
